import { Box, Button, Dialog, VisuallyHidden } from '@betterment/samba-react';

interface BalanceDisclosureModalProps {
  disclosure: string;
}

export const BalanceDisclosureModal: React.FC<BalanceDisclosureModalProps> = ({ disclosure }) => {
  return (
    <Dialog>
      <Dialog.Trigger asChild={true}>
        <Button variant="textSecondary" css={{ color: 'text.weak', fontSize: 'fontSize.25' }}>
          See disclosure
        </Button>
      </Dialog.Trigger>
      <Dialog.Content size="large" css={{ p: 'space.400' }}>
        <Dialog.Title>
          <VisuallyHidden>Balance Disclosure</VisuallyHidden>
        </Dialog.Title>
        <Dialog.Description asChild={true}>
          <Box dangerouslySetInnerHTML={{ __html: disclosure }} />
        </Dialog.Description>
      </Dialog.Content>
    </Dialog>
  );
};
